export const urlExtension = () => location.hostname.split('.').pop()
